import {Component, OnInit} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';
import {ActivatedRoute, Router} from '@angular/router';
import {DataService, DatasetBannerModel, DatasetBannerView} from 'src/app/services/data.service';
import {SessionService, UserType} from 'src/app/services/session.service';
import {MatTableDataSource} from '@angular/material/table';
import {TrustiiService} from 'src/app/services/trustii.service';
import {DialogService} from 'src/app/services/dialog.service';
import {tap, catchError} from 'rxjs/operators';
import {throwError} from 'rxjs';

@Component({
  selector: 'app-dataset-portal',
  templateUrl: './portal.component.html',
  styleUrls: ['./portal.component.scss']
})
export class PortalComponent implements OnInit {

  downloading = false;
  stats: any = {
    nbVendorParticipate: 0,
    nbVendorDownloadedTrainDatasets: 0,
    nbVendorDownloadedTestDatasets: 0,
    nbVendorSuccessPredictions: 0,
    nbVendorValidatedPredictions: 0,
  };
  showDetail = 'description';
  public dataSource: MatTableDataSource<any> = new MatTableDataSource([]);
  displayedColumns = ['feature', 'type', 'target', 'description'];
  enterpriseUser = null;

  constructor(private sessionService: SessionService,
              public domSanitizer: DomSanitizer,
              private trustiiService: TrustiiService,
              public dataservice: DataService,
              public dialogService: DialogService,
              public datasetBannerModel: DatasetBannerModel) {
  }

  ngOnInit() {
    if (this.dataservice.data.accountId === this.sessionService.getUser().roleId) {
      this.enterpriseUser = true;
    } else {
      this.enterpriseUser = false;
    }
    this.datasetBannerModel.setBannerView(DatasetBannerView.DatasetView);
    this.getStats();
    this.dataSource = new MatTableDataSource([]);
    this.dataSource.data = this.dataservice.data.fields;
    this.dataservice.dataStream.subscribe((data) => {
      this.dataSource = new MatTableDataSource([]);
      this.dataSource.data = this.dataservice.data.fields;
    });
  }

  getStats() {
    this.trustiiService.getStats(this.datasetBannerModel.dataset.id)
      .pipe(
        tap((stats: any) => this.stats = stats.data),
        catchError((error) => {
          return throwError(error);
        })
      ).subscribe();
  }
}
